module.exports = __webpack_public_path__ + "img/missed_notification_color.c91c98b2.svg";